import React from 'react';
import { Card, Typography } from 'antd';
import Rocket from '../../icons/rocket';

const { Text, Title } = Typography;

const EmptyTray: React.FC = () => {
  return (
    <Card styles={{ body: { textAlign: 'center' } }}>
      <div>
        <Rocket />
      </div>
      <Title level={5} style={{ marginTop: 0 }}>
        You are all set!
      </Title>
      <Text type="secondary">
        There&apos;s nothing for you to complete at the moment. Have a great
        day!
      </Text>
    </Card>
  );
};

export default EmptyTray;
